<ul
  class="fixed inset-x-5 bottom-5 grid grid-cols-1 place-items-center gap-5"
  [ngClass]="[
    navService.isSidebarOpen()
      ? 'sm:portrait:left-64 md:landscape:left-64'
      : 'sm:portrait:left-16 md:landscape:left-16',
  ]"
>
  @for (toast of toasts; track toast; let index = $index) {
    <div class="rounded-lg bg-white">
      <div
        class="relative rounded-lg border border-l-8 p-3 shadow-md"
        [ngClass]="toastStyle(toast.type)"
      >
        <h1 class="mb-3 mr-8 text-xl font-semibold capitalize">
          {{ toast.type }}
        </h1>
        <div class="mr-8 text-lg">{{ toast.message }}</div>
        <ag1-button
          class="absolute right-1 top-1"
          (clickEvent)="closeToast(index)"
          variant="secondary"
          tooltip="Close"
        >
          <svg-icon src="/assets/icons/general/close.svg" />
        </ag1-button>
      </div>
    </div>
  }
</ul>
